import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Ico_App",
  "use": "Ico_App-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"Ico_App\">\n    <path data-name=\"Union 53\" d=\"M3.111 19A1.061 1.061 0 0 1 2 18V6a1.061 1.061 0 0 1 1.111-1h17.778a1.061 1.061 0 0 1 1.112 1v12a1.061 1.061 0 0 1-1.112 1zm17.778-1V6H3.111v12H7V6h1v12zM10 16v-1h9v1zm0-2v-1h9v1zm-6-3v-1h2v1zm11-2V8h4v1zm-5 0V8h4v1zM4 9V8h2v1z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol